export default __webpack_public_path__ + "static/media/pantry2-before1-1920w.c740b722.png";